import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import MainLayout from '../../components/layout/MainLayout';

/**
 * Staff List Page (Admin)
 */
const StaffList: React.FC = () => {
  return (
    <MainLayout>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
          <Typography variant="h4">Staff</Typography>
          <Button variant="contained" startIcon={<AddIcon />}>
            Add Staff
          </Button>
        </Box>

        <Paper sx={{ p: 3 }}>
          <Typography variant="body1" color="textSecondary">
            Staff management page - Coming soon
          </Typography>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default StaffList;

